import { render, staticRenderFns } from "./SuratRujukan.vue?vue&type=template&id=a25e3b46&"
import script from "./SuratRujukan.vue?vue&type=script&lang=js&"
export * from "./SuratRujukan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports